import { math } from '../engine/math-sidecar'
import { assert } from './assert-sidecar'

export const TIME_ZERO_EPSILON = 0.00001

export const clamp1 = (v: number) => {
  return clamp(v, 0, 1)
}
export const clamp = (v: number, min: number, max: number) => {
  if (v < min) {
    v = min
  }
  if (v > max) {
    v = max
  }
  return v
}

export const cycle = (v: number) => {
  return v - Math.floor(v)
}

export const min = (a: number, b: number) => {
  return a < b ? a : b
}
export const max = (a: number, b: number) => {
  return a > b ? a : b
}
export const lerp = (a: number, b: number, t: number) => {
  return (1 - t) * a + t * b
}

export const betterMod = (v: number, m: number) => {
  return ((v % m) + m) % m
}

export const wrapIndex = (v: number, arr: any[]) => {
  return betterMod(v, arr.length)
}
export const getIndexWrapped = <T>(v: number, arr: T[]): T => {
  assert.t(arr.length > 0, 'array has no elements!')
  return arr[betterMod(v, arr.length)]
}
export const closeEnough = (a: number, b: number, e: number) => {
  return Math.abs(a - b) < e
}

export const isTimeZero = (t: number) => {
  return closeEnough(t, 0, TIME_ZERO_EPSILON)
}

export const distance = (x1: number, y1: number, x2: number, y2: number) => {
  let dx = x2 - x1
  let dy = y2 - y1
  return Math.sqrt(dx * dx + dy * dy)
}

export const sineLike = (
  t: number,
  scale: number,
  min: number,
  max: number,
) => {
  let dHalf = (max - min) / 2
  let v = min + dHalf + Math.sin(t * scale) * dHalf
  return v
}

// see: https://matthew-brett.github.io/teaching/rotation_2d.html
export const rotX = (x: number, y: number, rot: number) => {
  return Math.cos(rot) * x - Math.sin(rot) * y
}
export const rotY = (x: number, y: number, rot: number) => {
  return Math.sin(rot) * x + Math.cos(rot) * y
}
